import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, NavigationEnd, RouterLink, RouterLinkActive } from '@angular/router';
import { filter } from 'rxjs';
import { HttpClientModule } from '@angular/common/http';
import { ApiService } from '../services/api.service';
import { MenuService } from '../services/menu.service';

interface Module {
  name: string;
  route: string;
}

@Component({
  selector: 'app-side-nav',
  standalone: true,
  imports: [CommonModule, RouterLink, RouterLinkActive, HttpClientModule],
  templateUrl: './side-nav.component.html',
  styleUrls: ['./side-nav.component.scss']
})
export class SideNavComponent implements OnInit {
  modules: Module[] = [];
  currentPath: string = '';
  isProductActive: boolean = false;
  private hasNavigatedInitially = false;
  mobileMenuOpen = false;

  constructor(private router: Router, private api: ApiService, private menuService: MenuService) {

    this.menuService.menuOpen$.subscribe(open => {
      this.mobileMenuOpen = open;
    });

    // ✅ Listen for router events (after navigation)
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe((event: any) => {
        this.currentPath = event.urlAfterRedirects;

        // ✅ Always open dropdown when under /content
        if (this.currentPath.startsWith('/content')) {
          this.isProductActive = true;
        }
      });
  }

  ngOnInit(): void {
    // ✅ Capture the initial URL in case of refresh or direct load
    this.currentPath = this.router.url;
    if (this.currentPath.startsWith('/content')) {
      this.isProductActive = true;
    }

    this.fetchProjects();
  }

  fetchProjects(): void {
    this.api.get<Module[]>('/projects').subscribe({
      next: (res) => {
        this.modules = res.map(proj => ({
          name: proj.name,
          route: this.slugify(proj.name)
        }));

        // Auto-navigate to first project ONLY once and ONLY if not already on other pages
        const url = this.router.url;
        const isDashboard = url.startsWith('/dashboard');
        const isContent = url.startsWith('/content');
        const isMasters = url.startsWith('/masters');
        const isUpload = url.startsWith('/upload');

        if (
          !this.hasNavigatedInitially &&
          !isContent &&
          !isDashboard &&
          !isMasters &&
          !isUpload &&
          this.modules.length > 0
        ) {
          const first = this.modules[0];
          this.router.navigate(
            [`/content/${first.route}`],
            { queryParams: { tab: 'overview' }, replaceUrl: true }
          );
          this.hasNavigatedInitially = true;
        }
      },
      error: (err) => console.error('Error fetching projects:', err)
    });
  }


  slugify(name: string): string {
    return name.toLowerCase().replace(/\s+/g, '-');
  }

  toggleProjects(): void {
    this.isProductActive = !this.isProductActive;
  }

  // ✅ Make sure module highlight still works even with query params
  isModuleActive(module: Module): boolean {
    return this.currentPath.includes(`/content/${module.route}`);
  }
}
